'use client';

import React from 'react';
// import Head from 'next/head';
import { BlogDocument } from '@/models/blog';

interface Props {
  title: string;
  rating: BlogDocument['rating'];
}

const RatingJsonLd = ({ title, rating }: Props) => {
  const avgRating =
    rating.length > 0
      ? (
          rating.reduce(
            (a: number, b: { value: number; ip: string }) => a + b.value,
            0
          ) / rating.length
        ).toFixed(1)
      : null;

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CreativeWorkSeries',
    name: title,
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: avgRating,
      ratingCount: rating.length,
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
};

export default RatingJsonLd;
